import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Table, Button } from "react-bootstrap";
import { ContainerWrapper, ContainerBody, Content } from "../../../components/GridComponent/AdminLte.js";
import "./NHOFeedbackReport.css";
import moment from "moment";
import { connect } from "react-redux";
import {
  getNhoFeedbackReport,
  exportNhoFeedbackReport,
} from "../../../store/actions/report/reportActions";
import Wrapper from "../../../components/Template/Wrapper";
import ReportNavigatorShort from "../../../components/Template/ReportNavigatorShort/ReportNavigatorShort.js";
import Authenticator from "../../../services/Authenticator.js";

const NHOFeedbackReport = ({
  report,
  getNhoFeedbackReport,
  exportNhoFeedbackReport,
  ...props
}) => {
  const [start_date, setStartDate] = useState(
    moment().subtract(6, "d").startOf("day")
  );

  const [end_date, setEndDate] = useState(moment().endOf("day"));

  const isAllowed = useCallback(() => {
    return (
      Authenticator.scanLevel(["HR", "Admin"]) ||
      Authenticator.scanFeature("view_nho_report")
    );
  }, []);

  const handleSubmit = useCallback(() => {
    getNhoFeedbackReport(start_date, end_date);
  }, [getNhoFeedbackReport, start_date, end_date]);

  const handleExport = useCallback(() => {
    exportNhoFeedbackReport(start_date, end_date);
  }, [exportNhoFeedbackReport, start_date, end_date]);

  const handleChangeDate = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  useEffect(() => {
    if (isAllowed()) {
      getNhoFeedbackReport(start_date, end_date);
    }
  }, [isAllowed, getNhoFeedbackReport]);

  const nho_feedback_report = report.nho_feedback_report;

  if (!isAllowed()) {
    return (
      <Wrapper {...props}>
        <ContainerWrapper>
          <h2 className="header_text">NHO Feedback Report</h2>

          <div className="nho-report-empty">
            You are not allowed to view this report.
          </div>
        </ContainerWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper {...props}>
      <ContainerWrapper>
        <div className="nho-feedback-report">
          <h2 className="header_text">NHO Feedback Report</h2>

          <div className="navigator-bar">
            <ReportNavigatorShort
              start_date={start_date}
              end_date={end_date}
              handleChangeDate={handleChangeDate}
              default_view_type="day"
              hide_filter_button={true}
            />
          </div>

          <ContainerBody>
            <Content col="12">
              <Row className="">
                <Col size="2">
                  <div className="form-group">
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      <i className="fa fa-filter" /> Filter
                    </Button>
                    &nbsp;
                    <Button
                      variant="primary"
                      onClick={handleExport}
                    >
                      <i className="fa fa-download" /> Export
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row>
                {nho_feedback_report != null &&
                nho_feedback_report.length > 0 ? (
                  <Col size="2">
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      size="sm"
                      className="nho-report-table"
                    >
                      <thead>
                        <tr>
                          <th>NHO Date</th>
                          <th>Submitted At</th>
                          <th>Employee No</th>
                          <th>Employee</th>
                          <th>Date Hired</th>
                          <th>Facilitator</th>
                          <th>Onboarding</th>
                          <th>Recruitment</th>
                          <th>Schedule Awareness</th>
                          <th>Topic Relevance</th>
                          <th>Facilitator Knowledge</th>
                          <th>Facilitator Presentation</th>
                          <th>Facilitator Responsiveness</th>
                          <th>Equipment</th>
                          <th>Accessibility</th>
                          <th>Welcome</th>
                          <th>Suggestions</th>
                          <th>Overall Feedback</th>
                        </tr>
                      </thead>

                      <tbody>
                        {nho_feedback_report.map((item) => (
                          <tr key={item.id}>
                            <td>{item.nho_date}</td>
                            <td>{item.submitted_at_local}</td>
                            <td>{item.emp_num}</td>
                            <td>{item.employee_name}</td>
                            <td>{item.date_hired}</td>
                            <td>{item.facilitator_name}</td>
                            <td>{item.onboarding_exp_rating}</td>
                            <td>{item.recruitment_exp_rating}</td>
                            <td>{item.schedule_awareness_rating}</td>
                            <td>{item.topic_relevance_rating}</td>
                            <td>{item.facilitator_knowledge_rating}</td>
                            <td>{item.facilitator_presentation_rating}</td>
                            <td>{item.facilitator_response_rating}</td>
                            <td>{item.equipment_rating}</td>
                            <td>{item.accessibility_rating}</td>
                            <td>{item.welcome_rating}</td>
                            <td>{item.suggestions}</td>
                            <td>{item.nho_overall_feedback}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                ) : (
                  <div className="nho-report-empty">
                    No NHO feedback submitted within the selected dates.
                  </div>
                )}
              </Row>
            </Content>
          </ContainerBody>
        </div>
      </ContainerWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  report: state.report,
});

const mapDispatchToProps = (dispatch) => ({
  getNhoFeedbackReport: (start_date, end_date) =>
    dispatch(getNhoFeedbackReport(start_date, end_date)),

  exportNhoFeedbackReport: (start_date, end_date) =>
    dispatch(exportNhoFeedbackReport(start_date, end_date)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NHOFeedbackReport);